import { render, staticRenderFns } from "./DosageComponent.vue?vue&type=template&id=d228caf0&scoped=true"
import script from "./DosageComponent.vue?vue&type=script&lang=js"
export * from "./DosageComponent.vue?vue&type=script&lang=js"
import style0 from "./DosageComponent.vue?vue&type=style&index=0&id=d228caf0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d228caf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d228caf0')) {
      api.createRecord('d228caf0', component.options)
    } else {
      api.reload('d228caf0', component.options)
    }
    module.hot.accept("./DosageComponent.vue?vue&type=template&id=d228caf0&scoped=true", function () {
      api.rerender('d228caf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/appellation/DosageComponent.vue"
export default component.exports